
namespace RecordShield.Workspace {
    import fld = RecordShield.Workspace.ClientAnalyticsRow.Fields;
    @Serenity.Decorators.registerClass()
    export class ClientAnalyticsGrid extends Serenity.EntityGrid<ClientAnalyticsRow, any> {
        protected getColumnsKey() { return 'Workspace.ClientAnalytics'; }
        protected getDialogType() { return ClientAnalyticsDialog; }
        protected getLocalTextPrefix() { return ClientAnalyticsRow.localTextPrefix; }
        protected getService() { return ClientAnalyticsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getQuickFilters(): Serenity.QuickFilter<Serenity.Widget<any>, any>[] {

            // get quick filter list from base class
            let filters = super.getQuickFilters();

            // quick filter init method is a good place to set initial
            // value for a quick filter editor, just after it is created
            Q.first(filters, x => x.field == fld.StartedAt).init = w => {
                // w is a reference to the editor for this quick filter widget
                // here we cast it to DateEditor, and set its value as date.
                // note that in Javascript, months are 0 based, so date below
                // is actually 2016-05-01
                var nextDate = new Date();
                //nextDate.setDate(nextDate.getMonth() - 1);
                (w as Serenity.DateEditor).valueAsDate = new Date(nextDate.getFullYear(), nextDate.getMonth() - 1, nextDate.getDay());;

                // setting start date was simple. but this quick filter is actually
                // a combination of two date editors. to get reference to second one,
                // need to find its next sibling element by its class
                //let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
                //endDate.valueAsDate = new Date(2016, 6, 1);
            };

            return filters;
        }
        protected getButtons(): Serenity.ToolButton[] {
            var buttons = super.getButtons();
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            buttons.push(RecordShield.Common.ExcelExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit(),
                service: 'Workspace/ClientAnalytics/ListExcel',
                separator: true
            }));

            buttons.push(RecordShield.Common.PdfExportHelper.createToolButton({
                grid: this,
                onViewSubmit: () => this.onViewSubmit()
            }));


            return buttons;
        }
    }
}